import { columnChunkId } from './chunk';
import { tilesChunks } from './tilesChunks';

const unscheduledPlanDate = '0000-00-00';
const planTab = 'plan';
const userSubmittedTab = 'user_submitted';

const planDate = tile => (tile.planDate ? tile.planDate : unscheduledPlanDate);

const startingColumns = (initialTiles, status) => {
  if (status === planTab) {
    const columns = initialTiles
      .map(tile => planDate(tile))
      .concat([unscheduledPlanDate, userSubmittedTab]);

    return [...new Set(columns)].sort();
  }
  return ['generic'];
};

const columnTiles = (column, initialTiles, status) => {
  if (column === userSubmittedTab) {
    return initialTiles.filter(
      tile => tile.status === userSubmittedTab || tile.status === 'ignored',
    );
  }
  if (status === planTab) {
    return initialTiles.filter(
      tile => planDate(tile) === column && tile.status === planTab,
    );
  }
  return initialTiles;
};

const initializeDnDContext = (initialTiles, status, tilesPerRow) => {
  const initialColumns = startingColumns(initialTiles, status);
  const columns = {};
  const groupedColumns = {};
  const columnOrder = [];

  initialColumns.forEach(column => {
    const columnTilesCollection = columnTiles(column, initialTiles, status);

    const chunks = tilesChunks(column, columnTilesCollection, tilesPerRow);

    // this block keeps track of tiles on plan left side
    chunks.forEach((currentChunk, index) => {
      const columnId = columnChunkId(column, index);
      const columnAttributes = {
        id: columnId,
        title: column,
        tilesIds: currentChunk.map(tile => tile.id.toString()),
      };

      columnOrder.push(columnId);

      if (groupedColumns[column]) {
        groupedColumns[column] = groupedColumns[column].concat(columnId);
      } else {
        groupedColumns[column] = [columnId];
      }

      columns[columnId] = columnAttributes;
    });

    // this block helps keep track of placeholders on plan side left
    if (column === unscheduledPlanDate && chunks.length < 4) {
      const width = document.documentElement.clientWidth;
      const placeholdersQuantity = width < 2048 ? 7 : 8;
      const placeholders = placeholdersQuantity - columnTilesCollection.length;

      for (let i = 0; i < placeholders; i++) {
        const columnId = columnChunkId(column, i + chunks.length);
        const columnAttributes = {
          id: columnId,
          title: column,
          tilesIds: [],
        };

        columnOrder.push(columnId);

        groupedColumns[column] = groupedColumns[column]
          ? groupedColumns[column].concat(columnId)
          : [columnId];

        columns[columnId] = columnAttributes;
      }
    }
  });

  const tiles = initialTiles.reduce((acc, tile) => {
    return {
      ...acc,
      [`${tile.id}`]: tile,
    };
  }, {});

  const dndContextSection = {
    tiles,
    columns,
    columnOrder,
    groupedColumns,
  };
  return dndContextSection;
};

const addNewColumnToDnDContextSection = (
  currentDnDContextSection,
  newColumn,
) => {
  const { columns, columnOrder, groupedColumns } = currentDnDContextSection;
  const existingColumn = columns[newColumn];

  if (existingColumn) {
    return currentDnDContextSection;
  }

  columnOrder.push(newColumn);
  groupedColumns[newColumn] = [newColumn];

  const newColumnOrder = columnOrder.sort(
    (a, b) => a.replace(/-/g, '') - b.replace(/-/g, ''),
  );
  const newColumnAttributes = {
    id: newColumn,
    title: newColumn,
    tilesIds: [],
  };
  const newGroupedColumns = groupedColumns;

  columns[newColumn] = newColumnAttributes;

  const newColumns = columns;

  const newDnDContextSection = {
    ...currentDnDContextSection,
    columnOrder: newColumnOrder,
    groupedColumns: newGroupedColumns,
    columns: newColumns,
  };

  return newDnDContextSection;
};

export {
  initializeDnDContext,
  addNewColumnToDnDContextSection,
  startingColumns,
  columnTiles,
};
